// iter136 — Phase 2 mobile-only welcome hero. Renders a gradient brand-blue
// card on phones so the dashboard feels like an Android app's top stat-strip.
// Desktop (md+) keeps the existing plain text header (rendered by callers).
import { GraduationCap } from "lucide-react";

export default function MobileWelcomeHero({ schoolName, subtitle, accent }) {
  return (
    <section
      data-testid="mobile-welcome-hero"
      className="relative mb-4 overflow-hidden rounded-2xl bg-gradient-to-br from-brand-600 via-brand-600 to-brand-700 p-5 text-white shadow-lg md:hidden"
    >
      {/* decorative orbs */}
      <span className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-white/10 blur-2xl" aria-hidden />
      <span className="pointer-events-none absolute -bottom-8 -left-6 h-28 w-28 rounded-full bg-sun-500/30 blur-3xl" aria-hidden />
      <div className="relative flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/30">
          <GraduationCap className="h-6 w-6" strokeWidth={2.25} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-white/80">Welcome</p>
          <h1 className="mt-1 truncate text-lg font-bold leading-tight">{schoolName || "MDM Sahayak"}</h1>
          {/* iter151 — subtitle carries UDISE / mobile; mask from PostHog recordings. */}
          {subtitle && <p className="mt-1 text-xs text-white/85" data-private>{subtitle}</p>}
          {accent && (
            <p className="mt-2 inline-flex items-center gap-1 rounded-full bg-white/15 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider">
              {accent}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
